export class PurePriceOverride {
  active: boolean;
  purePrice: number;
  constructor(active: boolean, purePrice: number) {
    this.active = active;
    this.purePrice = purePrice;
  }

  isActive() {
    return this.active && this.hasPrice();
  }

  hasPrice() {
    return !!this.purePrice;
  }

  getPrice() {
    return this.purePrice;
  }
}
